import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';
import {
  ASK_ACCENT,
  ASK_ACCENT_DARK,
} from './askRecordUi';

const SourceMarker = ({ compact = false, number }) => (
  <Box
    component="span"
    sx={{
      display: 'inline-grid',
      placeItems: 'center',
      width: compact ? 17 : 20,
      height: compact ? 17 : 20,
      ml: compact ? 0.25 : 0.35,
      transform: 'translateY(-1px)',
      borderRadius: '999px',
      bgcolor: alpha(ASK_ACCENT, 0.16),
      color: ASK_ACCENT_DARK,
      fontSize: compact ? '0.66rem' : '0.75rem',
      lineHeight: 1,
      fontWeight: 950,
      verticalAlign: 'middle',
    }}
  >
    {number}
  </Box>
);

const AskRecordAnswerText = ({
  answer,
  compact = false,
  sources = [],
}) => {
  const paragraphs = String(answer || '')
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);
  const visibleSources = sources.slice(0, 3);

  return (
    <Box sx={{ minWidth: 0 }}>
      {paragraphs.map((paragraph, index) => (
        <Typography
          key={`${paragraph}-${index}`}
          sx={{
            mb: compact ? 0.65 : 0.9,
            fontSize: compact ? '0.88rem' : { xs: '0.9rem', sm: '0.96rem' },
            lineHeight: compact ? 1.38 : 1.42,
            color: colors.semantic.ink,
            fontWeight: compact ? 650 : 400,
          }}
        >
          {paragraph}
          {index === 0 && visibleSources.map((source, sourceIndex) => (
            <SourceMarker compact={compact} key={source.sourceId || source.id || sourceIndex} number={sourceIndex + 1} />
          ))}
        </Typography>
      ))}
    </Box>
  );
};

export default AskRecordAnswerText;
